export default {"src":"https://kroemtech.ch//_next/static/media/scycloud_logo_white.84d9b5a6.svg","height":92,"width":490,"blurWidth":0,"blurHeight":0};